export const PAGE_TEMPLATE_NO_HEADER = 'no-header';
